import styled from '@emotion/styled';
import { flexbox, layout, space } from 'styled-system';
import { useTranslation } from 'react-i18next';

import colors from 'lib/colors';
import shouldForwardProp from 'utils/shouldForwardProp';

import GameStatusIcon from '../GameStatusIcon';

import { SceneStatusFilterEnum } from './MatchView';

interface MatchViewFilterButtonProps {
  isWithIcon?: boolean;
  labelKey: SceneStatusFilterEnum;
  disabled?: React.ButtonHTMLAttributes<HTMLButtonElement>['disabled'];
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const MatchViewFilterButton = ({
  isWithIcon,
  labelKey,
  disabled,
  active,
  onClick,
}: MatchViewFilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <FilterButton
      disabled={disabled}
      active={active}
      onClick={disabled ? undefined : onClick}
    >
      {isWithIcon && (
        <div>
          <GameStatusIcon iconKey={labelKey} />
        </div>
      )}
      <div>{t(`matchView.filter.${labelKey.toLowerCase()}`, labelKey)}</div>
    </FilterButton>
  );
};

interface FilterButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  disabled?: boolean;
}

const FilterButton = styled('button', {
  shouldForwardProp: shouldForwardProp(),
})<FilterButtonProps>`
  margin-left: 0.5em;

  display: flex;
  align-items: center;
  ${flexbox}

  font-family: inherit;
  font-weight: normal;
  font-size: 1em;
  letter-spacing: 0;

  color: ${(props) => (props.active ? colors.lobbyOrange : colors.white)};
  background: transparent;
  border: none;

  &:hover {
    color: ${(props) => (props.disabled ? colors.white : colors.lobbyOrange)};
  }

  &:disabled {
    cursor: auto;
    opacity: 0.5;
  }

  ${layout}
  ${space}
`;

export default MatchViewFilterButton;
